import React, { useState, useEffect } from 'react';
import NotFound404 from '../components/404';
import WorkflowComponent from '../components/AppManagement1';
import WebDeveloperSection from '../components/AppManagement2';
import AppBanner from '../components/AppBanner';
import ITServicesHero from '../components/AppManagementConsult';
import ServicesShowcase from '../components/AppManagement3';

function AppManagement() {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Responsive style calculation function
  const calculateResponsiveStyle = (baseValue, multiplier = 1) => {
    if (screenWidth <= 375) {  // Small mobile
      return `${baseValue * 0.6 * multiplier}px`;
    } else if (screenWidth <= 576) {  // Mobile
      return `${baseValue * 0.8 * multiplier}px`;
    } else if (screenWidth <= 768) {  // Tablet
      return `${baseValue * 0.9 * multiplier}px`;
    } else if (screenWidth <= 992) {  // Small desktop
      return `${baseValue * 1 * multiplier}px`;
    } else {  // Large desktop
      return `${baseValue * 1.1 * multiplier}px`;
    }
  };

  const containerStyle = {
    width: '100%',
    overflowX: 'hidden',
    padding: calculateResponsiveStyle(10, 2),
  };

  const sectionStyles = {
    marginTop: calculateResponsiveStyle(10),
    marginBottom: calculateResponsiveStyle(10),
  };

  const heroStyles = {
    WebDeveloper: {
      marginTop: calculateResponsiveStyle(-20),
      marginBottom: calculateResponsiveStyle(10),
    },
    Workflow: {
      marginTop: calculateResponsiveStyle(-30),
      marginBottom: calculateResponsiveStyle(10),
    },
    ITServices: {
      marginTop: calculateResponsiveStyle(-40),
      marginBottom: calculateResponsiveStyle(10),
    }
  };

  return (
    <div style={containerStyle}>
      <AppBanner />
      
      <div style={sectionStyles}>
        <ServicesShowcase />
      </div>
      
      <div style={{
        ...sectionStyles,
        ...heroStyles.WebDeveloper
      }}>
        <WebDeveloperSection />
      </div>
      
      <div style={{
        ...sectionStyles,
        ...heroStyles.Workflow
      }}>
        <WorkflowComponent />
      </div>
      
      <div style={{
        ...sectionStyles,
        ...heroStyles.ITServices
      }}>
        <ITServicesHero />
      </div>
    </div>
  );
}

export default AppManagement;